// THIS FILE IS GENERATED AUTOMATICALLY

import dashboard from "./dashboard";
import news from "./news";
import knowledgeBase from "./knowledgeBase";
import idd from "./idd";
import trainings from "./trainings";
import training from "./training";
import onboarding from "./onboarding";
import videoPlayer from "./videoPlayer";
import notifications from "./notifications";
import surveys from "./surveys";
import competence from "./competence";
import teamIndicators from "./teamIndicators";
import gamification from "./gamification";
import certificates from "./certificates";
import profile from "./profile";
import scrollLesson from "./scrollLesson";
import anonSurvey from "./anonSurvey";
import form from "./form";
import { ProfileCompetenceList } from "./competence/components/profileCompetenceList/profileCompetenceList.component.js";
import { VideoSection } from "./videoPlayer/components/videoSection/videoSection.component.js";

export const Modules = {
  dashboard,
  news,
  knowledgeBase,
  idd,
  trainings,
  training,
  onboarding,
  videoPlayer,
  notifications,
  surveys,
  competence,
  teamIndicators,
  gamification,
  certificates,
  profile,
  scrollLesson,
  anonSurvey,
  form,
};

export const ModuleType = {
  Dashboard: "dashboard",
  News: "news",
  KnowledgeBase: "knowledgeBase",
  Idd: "idd",
  Trainings: "trainings",
  Training: "training",
  Onboarding: "onboarding",
  VideoPlayer: "videoPlayer",
  Notifications: "notifications",
  Surveys: "surveys",
  Competence: "competence",
  TeamIndicators: "teamIndicators",
  Gamification: "gamification",
  Certificates: "certificates",
  Profile: "profile",
  ScrollLesson: "scrollLesson",
  AnonSurvey: "anonSurvey",
  Form: "form",
};

export const Widgets = {
  ProfileCompetenceList,
  VideoSection,
};

export const WidgetType = {
  ProfileCompetenceList: "ProfileCompetenceList",
  VideoSection: "VideoSection",
};
